import React from 'react'
import * as Util from '../util/Util'
import About from './About'

export default(props)=>{
  const {t} = props
  const md = t(`privacy`,About)
  return (
    <div className="mt-6">
      <h1 className="text-center content-title text-shadow">{t('key:privacy')}</h1>
      <div className="main-content">
        <div dangerouslySetInnerHTML={Util.fromMd(md)} />
      </div>
    </div>
  )
}
